import { useShellText } from "../../i18n/useShellText";
/**
 * DemoBanner — thin persistent banner displayed at the very top of the
 * app shell when the server is running in demo mode.
 *
 * Renders above the TopBar and sidebar. Uses the QuickBox accent gradient
 * so the banner feels native across all four themes.
 */
import { Icon } from "../ui/Icon";

const PRICING_URL = "https://v3.quickbox.io/pricing";

export const DemoBanner = () => { const { text: ui, t } = useShellText(); return (
  <div
    className="relative z-50 flex items-center justify-center gap-3 px-4 py-1.5 text-xs font-medium sm:text-sm"
    style={{
      background:
        "linear-gradient(90deg, rgb(var(--primary) / 0.85), rgb(var(--accent) / 0.85))",
      color: "rgb(var(--primary-foreground))",
    }}
    role="status"
    aria-label={ui("Demo mode active")}
  >
    <Icon icon="lucide:sparkles" className="h-3.5 w-3.5 flex-shrink-0 opacity-80" aria-hidden="true" />
    <span>
      {t($ => $.demoMessage)}
    </span>
    <a
      href={PRICING_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="ml-1 inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors"
      style={{
        background: "rgb(var(--primary-foreground) / 0.2)",
        color: "rgb(var(--primary-foreground))",
      }}
    >
      {ui("Get QuickBox Pro")}<Icon icon="lucide:arrow-up-right" className="h-3 w-3" aria-hidden="true" />
    </a>
  </div>
); };
